import userPlaceholder from "../assets/user.png";
import CustomButton from "@/components/CustomButton";
import { useMsal } from "@azure/msal-react";
import { Popup } from "devextreme-react";
import { PopupRef, Position } from "devextreme-react/popup";
import { signOutClickHandler } from "@/helper/helper";
import { useNavigate } from "react-router";
import { useAppSelector } from "@/hooks/useAppSelector";
import AppVersion from "./AppVersion";

type Props = {
  userPopupRef: React.RefObject<PopupRef>;
};
export default function UserPopup({ userPopupRef }: Props) {
  const { instance } = useMsal();
  const { user } = useAppSelector((state) => state.system);
  const navigate = useNavigate();

  return (
    <Popup
      width={380}
      height={"fit"}
      onShowing={(e) => {
        const el = e.component.content();
        el.style.padding = "16px";
      }}
      showTitle={false}
      hideOnOutsideClick={true}
      id="user-popup"
      ref={userPopupRef}
      shading={false}
    >
      <Position at="center" my="right top" of="#user-data" offset={{ x: 65, y: 30 }} />
      <div className="flex w-full flex-wrap gap-4">
        <div className="flex w-full items-center gap-4">
          <img
            src={user?.photo || userPlaceholder}
            alt=""
            className="h-16 w-16 rounded-full object-cover"
          />
          <div>
            <span className="block overflow-hidden text-ellipsis whitespace-nowrap text-lg font-medium">
              {user?.name}
            </span>
            <span className="block overflow-hidden text-ellipsis whitespace-nowrap">
              {user?.username}
            </span>
          </div>
        </div>
        <div className="flex w-full items-center justify-between">
          <img src="/logo.svg" />
        </div>
        <div className="flex w-full justify-between">
          <CustomButton
            text="Settings"
            variant="primary"
            className="min-w-[113px] !py-1"
            onClickHandler={() => navigate("/household")}
          />
          <CustomButton
            text="Sign Out"
            className="!py-1"
            onClickHandler={() => signOutClickHandler(instance, user?.id as string)}
          />
        </div>
        <AppVersion className="relative flex bg-transparent text-xs text-black" />
      </div>
    </Popup>
  );
}
